import type { Fallacy } from "./types";
import { createStory } from "./types";

export const baseRateFallacy: Fallacy = {
    id: "base-rate-fallacy",
    name: "Base Rate Fallacy",
    emoji: "📊",
    category: "Manipulasi Statistik",
    description: "Mengabaikan **probabilitas dasar** (base rate) saat mengevaluasi informasi baru, sehingga **melebih-lebihkan kemungkinan** kejadian.",
    tldr: "Lupa hitung peluang dasarnya, langsung panik sama angka yang kelihatan besar.",
    detail: "Base Rate Fallacy terjadi ketika seseorang mengabaikan **informasi statistik dasar** (base rate) dan terlalu fokus pada **informasi spesifik** atau kasus individual.\n\nContoh: sebuah tes penyakit memiliki akurasi 99%. Jika hasilmu positif, apakah kamu pasti sakit? Jika penyakit itu hanya menyerang 1 dari 10.000 orang, maka dari 10.000 yang dites, sekitar 100 orang sehat mendapat hasil positif palsu, sementara hanya 1 yang benar-benar sakit. Kemungkinanmu sakit hanya sekitar 1%.\n\nMedia sering memanfaatkan kekeliruan ini dengan melaporkan angka tanpa konteks. 'Kasus X meningkat 200%!' terdengar menakutkan, tapi jika base rate-nya 1 dari sejuta, peningkatan itu masih sangat kecil. Selalu tanyakan: **berapa angka dasarnya** sebelum bereaksi terhadap statistik.",
    story: createStory("Base Rate Fallacy", "📊", {
      hook: {
        title: "Tes akurasinya 95%, hasilnya positif.",
        body: "Berarti 95% kamu sakit? Spoiler: belum tentu. Jauh dari itu malah.",
      },
      convo: {
        claim: "Tes screening kanker aku positif dan **akurasinya 90%**. Berarti kemungkinan aku kena kanker 90% dong, aku harus langsung kemo!",
        response: "Penyakitnya langka, false positive jauh lebih banyak. **Akurasi tes bukan peluang kamu sakit.**",
      },
      reveal: {
        body: "Kamu **lupa ngitung peluang dasarnya** dan langsung panik sama angka yang keliatan besar. Akurasi tes **gak sama dengan** peluang kamu beneran kena.",
      },
      insight: {
        title: "Kenapa bisa begitu?",
        body: "Kalau penyakitnya langka, yang **salah dibilang positif** jauh lebih banyak daripada yang beneran sakit. Akurasi tes tinggi bukan berarti peluang kamu sakit juga tinggi.",
      },
      engagement: {
        title: "Pernah panik gara-gara angka yang keliatan besar? 😱",
        body: "Hasil tes kesehatan atau berita statistik? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["survivorship-bias", "hasty-generalization", "misleading-statistics", "gamblers-fallacy"],
  };
